import namespace from './namespace';

export default {
    [namespace.getters.CONFIGURATION]: (state) => {
        return state[namespace.state.CONFIGURATION];
    },
    [namespace.getters.WAITING_FOR_RESPONSE]: (state) => {
        return state[namespace.state.WAITING_FOR_RESPONSE];
    },
    [namespace.getters.LOADING_MESSAGE]: (state) => {
        return state[namespace.state.LOADING_MESSAGE];
    },
    [namespace.getters.VIEW_NOTIFICATION]: (state) => {
    	return state[namespace.state.VIEW_NOTIFICATION];
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/smtp/getters.js